// Posts a message from the edulla-chat iframe up to the edulla-chat-start
// launcher that hosts it. The launcher listens on its own `window` for
// `message` events (see edulla-chat-start FrameUtils), so the reliable channel
// is `window.parent.postMessage` with a wildcard target origin.
//
// We intentionally do NOT read `window.parent.location` here: the parent is a
// different origin in production and accessing its location throws. Using
// targetOrigin "*" lets the post succeed cross-origin; the launcher filters on
// the `isEdulla` flag. When not embedded (parent === window) we skip.
export type LauncherMessage = {
    isEdulla: true;
    action: string;
    data?: unknown;
};

export const postToLauncher = (message: LauncherMessage): void => {
    try {
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(message, '*');
        }
    } catch (_) {
        // Swallow: a failed cross-frame post must never break the chat.
    }
};
